export default function guest({ next, }) {
    if (localStorage.getItem('authStatus')) {
        return next()
    }

    return next({
        name: 'login'
    })
}